import { render, staticRenderFns } from "./compactSidebar.vue?vue&type=template&id=05a6c465&scoped=true&"
import script from "./compactSidebar.vue?vue&type=script&lang=js&"
export * from "./compactSidebar.vue?vue&type=script&lang=js&"
import style0 from "./compactSidebar.vue?vue&type=style&index=0&id=05a6c465&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a6c465",
  null
  
)

export default component.exports